"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_COPY_PERCENTAGE = exports.CHARS_PER_PAGE = void 0;
var MAX_COPY_PERCENTAGE = exports.MAX_COPY_PERCENTAGE = 15;
var CHARS_PER_PAGE = exports.CHARS_PER_PAGE = 1024;